
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import { twMerge } from 'tailwind-merge';
import styles from '../../../components/pages/legal/legal.module.css';
import { Footer } from '@unreserved-frontend-v2/ui/footer/footer';
import { FooterMobile } from '@unreserved-frontend-v2/ui/footer/footer-mobile';
import { ResponsiveWidth } from '@unreserved-frontend-v2/ui/responsive-width/responsive-width';
import { SEOHeader } from '@unreserved-frontend-v2/ui/SEO-header/desktop';
import AppHeader from '../../../components/header/app-header';
import { MainMenuKey } from '../../../components/hooks/use-menu-items';
export function PrivacyPolicy() {
    const listingBreadcrumbValues = {
        title: 'Privacy Policy',
        breadcrumbItems: [
            { label: 'Legal', id: 'legal' },
            { label: 'Privacy Policy', id: 'privacy-policy' },
        ]
    };
    return (<div>
      <AppHeader pageKey={MainMenuKey.LEARN_MORE}/>
      <div className="bg-shades-25">
        <ResponsiveWidth className="py-6">
          <SEOHeader settings={listingBreadcrumbValues} shareButton={false}/>
          <p className="pt-[17px] text-sm font-bold uppercase">Last modified: January 25, 2023</p>
          <div className="leading-[28px]">
            <p>
              <br />
            </p>
            <p>
              Unreserved Realty Inc. (&quot;<b>We</b>&quot;) respects your privacy and is committed to protecting it by
              complying with this policy. If you have any questions or concerns about this privacy policy, or our
              practices with regards to your personal information, please contact us at{' '}
              <a href="mailto:privacy@unreserved.com" target="_blank" rel="noreferrer">
                privacy@unreserved.com
              </a>
              .
            </p>
            <p>
              <br />
            </p>
            <p>This policy seeks to clearly describe:</p>
            <ul className={twMerge(`${styles.bullet}`, 'ml-[50px]')}>
              <li>
                The types of information we collect from our costumers and website users (&quot;<b>you</b>&quot;);
              </li>
              <li>The purposes for collection; and</li>
              <li>How we collect, use, disclose, and protect your personal.</li>
            </ul>
            <p>
              <br />
            </p>
            <p>
              We take your privacy very seriously and appreciate that you are trusting us with your personal
              information. We will use your personal information in accordance with this policy unless otherwise
              required by applicable law. We take steps to ensure that the personal information we collect about you is
              adequate, relevant, not excessive, and used for limited purposes.
            </p>
            <p>
              <br />
            </p>
            <p>
              Privacy laws in Canada generally define &quot;personal information&quot; as any information about an
              identifiable individual, which includes information that can be used on its own or with other information
              to identify, contact, or locate a single person. Personal information does not include business contact
              information, including your name, title, or business contact information.
            </p>
            <p>
              <br />
            </p>
            <p>This policy applies to information we collect, use, or disclose about you:</p>
            <ul className={twMerge(`${styles.bullet}`, 'ml-[50px]')}>
              <li>
                on the website <a href="https://unreserved.com/">unreserved.com</a> (our &quot;<b>Website</b>&quot;);
              </li>

              <li>via email, text, and other electronic messages between you and our Website; </li>

              <li>
                through mobile and desktop applications you download from our Website, which provide dedicated
                non-browser-based interaction between you and this Website;
              </li>

              <li>
                when you interact with our advertising and applications on third-party websites and services if those
                advertising or applications include links to this policy; or
              </li>

              <li>when you use any other of our services. </li>
            </ul>
            <p>
              <br />
            </p>
            <p>
              Our Website may include links to third-party websites, plug-ins, services, social networks, or
              applications. Clicking on those links or enabling those connections may allow the third party to collect
              or share data about you. If you follow a link to a third-party website or engage a third-party plugin,
              please note that these third parties have their own privacy policies and we do not accept any
              responsibility or liability for these policies. We do not control these third-party websites, and we
              encourage you to read the privacy policy of every website you visit or third-party plugin you use.
            </p>
            <p>
              <br />
            </p>
            <p>
              Please read this policy carefully to understand our policies and practices for collecting, processing, and
              storing your information. If you do not agree with our policies and practices, your choice is not to use
              our Website. By accessing or using our Website and services, you indicate that you understand, accept, and
              consent to the practices described in this policy. This policy may change from time to time. We will
              notify you in advance of any material changes to this policy, and your continued use of our Website after
              being notified of the material changes will indicate you understand, accept and consent to any new ways
              that we collect, use, and disclose your personal information.
            </p>
            <h2 className={styles.heading}>1. INFORMATION DO WE COLLECT ABOUT YOU</h2>
            <p>We collect and use the following information from and about you:</p>

            <ul className={twMerge(`${styles.bullet}`, 'ml-[50px]')}>
              <li>
                <b>Personal information,</b> that we can reasonably use to directly or indirectly identify you, such as
                your name, mailing address, e-mail address, telephone number, Internet protocol (IP) address used to
                connect your computer to the Internet, user name or other similar identifier, passwords, contact or
                authentication data, data collected from surveys, billing and account information, and any other
                identifier we may use to contact you or to verify your identity such as name, social insurance number or
                other personal ID number, date of birth, place of birth, purpose of buying or signature (the &quot;
                <b>personal information</b>&quot;).
              </li>
              <li>
                <b>Social Media Login Data,</b> our Website offers you the ability to register and login using your
                third-party social media account details (like your Facebook or Twitter logins). Where you choose to do
                this, we will receive certain profile information about you from your social media provider. The profile
                information we receive may vary depending on the social media provider concerned, but will often include
                your name, email address, friends list, profile picture as well as other information you choose to make
                public on such social media platform.
              </li>
              <li>
                <b>Transaction data,</b> our Website collects data regarding listings, bids, purchases, or sales in a
                transaction. This information is collected automatically when you use our websites, mobile apps and
                webservices to bid or buy.
              </li>
              <li>
                <b>Payment information,</b> our Website offers the ability to process payments therefore we may collect
                the banking information (account numbers and payment details) and credit card information necessary to
                process a bidding deposit or transaction. This personal information is provided by you when listing,
                buying or selling at an auction or by private sale, purchasing value-added services, creating or
                updating an account or otherwise interacting with us.
              </li>
              <li>
                <b>Non-personal information,</b> that does not directly or indirectly reveal your identity or directly
                relate to an identifiable individual, such as browser and device characteristics, operating system,
                language preferences, referring URLs, device name, country, location, information about how and when you
                use our Website and other technical information,{' '}
              </li>
              <li>
                <b>Technical information,</b> including your login information, browser type and version, time zone
                setting, browser plug-in types and versions, operating system and platform, or information about your
                internet connection, the equipment you use to access our Website, and usage details.{' '}
              </li>
              <li>
                <b>Non-personal details about your interactions with our Website,</b> including the full Uniform
                Resource Locators (URLs), clickstream to, through and from our Website (including date and time),
                products you viewed or searched for, page response times, download errors, length of visits to certain
                pages, page interaction information (such as scrolling, clicks, and mouse-overs), methods used to browse
                away from the page, or any phone number used to call our customer service number.
              </li>
            </ul>
            <h2 className={styles.heading}>2. HOW WE COLLECT INFORMATION ABOUT YOU</h2>

            <p>We use the following different methods to collect your information:</p>

            <ul className={twMerge(`${styles.bullet}`, 'ml-[50px]')}>
              <li>
                <b>By direct interactions with you when you provide it to us,</b> for example, by filling in forms or
                corresponding with us by phone, email, or otherwise.
              </li>
              <li>
                <b>By using the option to register with us with your existing social media account details,</b> for
                example registering to our Website with your Facebook, Twitter or other social media account.
              </li>
              <li>
                <b>User contributions.</b> You may also provide information for us to publish or display on public
                Website areas or transmit to other Website users or third parties, such as pictures of your property or
                your testimony.
              </li>
              <li>
                <b>Automated technologies or interactions,</b> as you navigate through our Website. Information
                collected automatically may include usage details, IP addresses, and information collected through
                cookies.
              </li>
              <li>
                <b>Third parties or publicly available sources,</b> for example, we may obtain information about you
                from other sources, such as public databases, joint marketing partners, affiliate programs, data
                providers, social media platforms, as well as from other third parties.
              </li>
            </ul>

            <h2 className={styles.heading}>2.1 Information You Provide to Us</h2>

            <p>The information we collect directly from you on or through our Website may include:</p>
            <ul className={twMerge(`${styles.bullet}`, 'ml-[50px]')}>
              <li>
                information that you provide by filling in forms on our Website. This includes information provided at
                the time of registering to use our Website and requesting further services. We may also ask you for
                information when you enter a contest or promotion sponsored by us, and when you report a problem with
                our Website;
              </li>
              <li>records and copies of your correspondence (including email addresses), if you contact us</li>
              <li>your responses to surveys that we might ask you to complete for research purposes; or</li>
              <li>your search queries on our Website.</li>
            </ul>
            <p>
              You may also provide information to be published or displayed (hereinafter, &quot;<b>posted</b>&quot;) on
              public areas of the Website or transmitted to other users of the Website or third parties (collectively,
              &quot;<b>User Contributions</b>&quot;). Your User Contributions are posted on and transmitted to others at
              your own risk. Additionally, we cannot control the actions of other users of the Website with whom you may
              choose to share your User Contributions. Therefore, we cannot and do not guarantee that unauthorized
              persons will not view your User Contributions.
            </p>

            <h2 className={styles.heading}>
              2.2 Information We Collect Through Cookies and Other Automatic Data Collection Technologies{' '}
            </h2>
            <p>
              As you navigate through and interact with our Website, we may use cookies or other automatic data
              collection technologies to collect certain information about your equipment, browsing actions, and
              patterns, including:
            </p>

            <ul className={twMerge(`${styles.bullet}`, 'ml-[50px]')}>
              <li>
                details of your visits to our Website, including traffic data, location data, logs, and other
                communication data and the resources that you access and use on the Website; or
              </li>
              <li>
                information about your computer and internet connection, including your IP address, operating system,
                and browser type.
              </li>
            </ul>
            <p>
              The information we collect automatically is statistical information and may include personal information,
              and we may maintain it or associate it with personal information we collect in other ways, that you
              provide to us, or receive from third parties. It helps us to improve our Website and to deliver a better
              and more personalized service, including by enabling us to:
            </p>
            <ul className={twMerge(`${styles.bullet}`, 'ml-[50px]')}>
              <li>estimate our audience size and usage patterns;</li>
              <li>
                store information about your preferences, allowing us to customize our Website according to your
                individual interests;
              </li>
              <li>speed up your searches; and</li>
              <li>recognize you when you return to our Website.</li>
            </ul>

            <p>The technologies we use for this automatic data collection may include:</p>

            <ul className={twMerge(`${styles.bullet}`, 'ml-[50px]')}>
              <li>
                <b>Cookies (or browser cookies).</b> A cookie is a small file placed on the hard drive of your computer.
                Most browsers are set to accept cookies by default. You can configure your browser to accept or reject
                all cookies or even notify you when a cookie is sent. However, if you do not accept cookies, certain
                features of our Website may not be available to you and its functionality may be affected.
              </li>
              <li>
                <b>Flash Cookies.</b> Certain features of our Website may use local stored objects (or Flash cookies) to
                collect and store information about your preferences and navigation to, from, and on our Website. Flash
                cookies are not managed by the same browser settings that are used for browser cookies.
              </li>
              <li>
                <b>Web Beacons.</b> Pages of our Website and our e-mails may contain small electronic files known as web
                beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit us, for example,
                to count users who have visited those pages or opened an email and for other related website statistics
                (for example, recording the popularity of certain website content and verifying system and server
                integrity).
              </li>
            </ul>

            <p>
              We partner with Microsoft Clarity and Microsoft Advertising to capture how you use and interact with our
              website through behavioral metrics, heatmaps, and session replay to improve and market our
              products/services. Website usage data is captured using first and third-party cookies and other tracking
              technologies to determine the popularity of products/services and online activity. Additionally, we use
              this information for site optimization, fraud/security purposes, and advertising. For more information
              about how Microsoft collects and uses your data, visit the{' '}
              <a href="https://privacy.microsoft.com/privacystatement">Microsoft Privacy Statement</a>.
            </p>

            <h2 className={styles.heading}>2.3 Third party ad servers </h2>

            <p>
              Some content or applications on the Website, including advertisements, are served by third parties,
              including advertisers, ad networks and servers, content providers, and application providers. These third
              parties may use cookies alone or in conjunction with web beacons or other tracking technologies to collect
              information about you when you use our Website. The information they collect may be associated with your
              personal information or they may collect information, including personal information, about your online
              activities over time and across different websites and other online services. They may use this
              information to provide you with interest-based (behavioural) advertising or other targeted content.
            </p>
            <p>
              <br />
            </p>
            <p>
              To opt-out of several third-party ad servers&lsquo; and networks&lsquo; cookies, please see Section 6
              below.
            </p>

            <h2 className={styles.heading}>3. HOW WE USE YOUR INFORMATION</h2>

            <p>
              We use information that we collect about you or that you provide to us, including any personal
              information:
            </p>

            <ul className={twMerge(`${styles.bullet}`, 'ml-[50px]')}>
              <li>
                <b>To present our Website and its contents to you.</b>
              </li>
              <li>
                <b>To facilitate account creation and logon process.</b> If you choose to link your account with us to a
                third-party account (such as your Google or Facebook account), we use the information you allowed us to
                collect from those third parties to facilitate account creation and logon process for the performance of
                the contract.
              </li>
              <li>
                <b>To provide you with information or services</b> that you request from us.
              </li>
              <li>
                <b> To request feedback.</b> We may use your information to request feedback and to contact you about
                your use of our Services.
              </li>
              <li>
                <b>To post testimonials.</b> We post testimonials on our Website that may contain personal information.
                Prior to posting a testimonial, we will obtain your consent to use your name and the content of the
                testimonial. If you wish to update, or delete your testimonial, please contact us at{' '}
                <a href="mailto:privacy@unreserved.com" target="_blank" rel="noreferrer">
                  privacy@unreserved.com
                </a>{' '}
                and be sure to include your name, testimonial location, and contact information.
              </li>
              <li>
                <b>To protect our Services.</b> We may use your information as part of our efforts to keep our Services
                safe and secure (for example, for fraud monitoring and prevention).
              </li>
              <li>
                <b>To carry out our obligations and enforce our rights arising from any contracts with you,</b>{' '}
                including for billing and collection or to comply with legal requirements.
              </li>
              <li>
                <b>To notify you</b> about changes to our Website or any products or services we offer or provide though
                it.
              </li>
              <li>
                <b>
                  To improve our Website, products or services, marketing, or customer relationships and experiences.
                </b>
              </li>
              <li>
                <b>To respond to legal requests and prevent harm.</b> If we receive a subpoena or other legal request,
                we may need to inspect the data we hold to determine how to respond.
              </li>
              <li>
                <b>To respond to user inquiries/offer support to users.</b> We may use your information to respond to
                your inquiries and solve any potential issues you might have with the use of our Services.
              </li>
              <li>
                <b>To administer prize draws and competitions.</b> We may use your information to administer prize draws
                and competitions when you elect to participate in our competitions.
              </li>
              <li>
                <b>To send you marketing and promotional communications.</b> We and/or our third-party marketing
                partners may use the personal information you send to us for our marketing purposes, if this is in
                accordance with your marketing preferences.
              </li>
              <li>
                <b>To send administrative information to you.</b> We may use your personal information to send you
                product, service and new feature information and/or information about changes to our terms, conditions,
                and policies.
              </li>
              <li>
                <b>To deliver targeted advertising to you.</b> We may use your information to develop and display
                personalized content and advertising (and work with third parties who do so) tailored to your interests
                and/or location and to measure its effectiveness.{' '}
              </li>
              <li>
                <b>For other business purposes.</b> We may use your information for other business purposes, such as
                data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and
                to evaluate and improve our Website, Services, products, marketing and your experience. We may use and
                store this information in aggregated and anonymized form so that it is not associated with individual
                end users and does not include personal information.{' '}
              </li>
              <li>In any other way we may describe when you provide the information.</li>
              <li>For any other purpose with your consent.</li>
            </ul>

            <h2 className={styles.heading}>4. DISCLOSURE OF YOUR INFORMATION</h2>

            <p>
              We may disclose personal information that we collect, or you provide as described in this privacy policy:
            </p>
            <ul className={twMerge(`${styles.bullet}`, 'ml-[50px]')}>
              <li>to our subsidiaries and affiliates;</li>
              <li>
                in accordance with applicable law, to a buyer or other successor in the event of a merger, divestiture,
                restructuring, reorganization, dissolution, or other sale or transfer of some or all of our assets,
                whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which
                personal information we hold about our customers and users is among the assets transferred;
              </li>
              <li>
                to advertisers and advertising networks that require the information to select and serve relevant
                advertisements to you and others. We do not disclose data about identifiable individuals to our
                advertisers, but we may provide them with aggregate information about our users (for example, we may
                inform them that 400 women between 30 and 45 have clicked on their advertisement on a specific day. We
                may also use such aggregate information to help advertisers target a specific audience (for example, men
                in a specific location). We may make use of the personal information we have collected from you to
                enable us to display our advertisers&lsquo; advertisement to that target audience;
              </li>
              <li>
                to third parties to market their products or services to you if you have consented to/not opted out of
                these disclosures. We contractually require these third parties to keep personal information
                confidential and use it only for the purposes for which we disclose it to them;
              </li>
              <li>
                to contractors, service providers, and other third parties we use to support our business (such as
                analytics and search engine providers that assist us with Website improvement and optimization) and who
                are contractually obligated to keep personal information confidential, use it only for the purposes for
                which we disclose it to them, and to process the personal information with the same standards set out in
                this policy;
              </li>
              <li>to fulfill the purpose for which you provide it;</li>
              <li>
                to comply with any court order, law, or legal process, including to respond to any government or
                regulatory request, in accordance with applicable law;
              </li>
              <li>to enforce or apply our terms of use and other agreements;</li>
              <li>
                If we believe disclosure is necessary or appropriate to protect the rights, property, or our safety, our
                customers, or others. This includes exchanging information with other companies and organizations for
                the purposes of fraud protection and credit risk reduction;
              </li>
              <li>for any other purpose disclosed by us when you provide the information; or</li>
              <li>to anyone else with your consent.</li>
            </ul>

            <h2 className={styles.heading}>5. TRANSFERRING YOUR PERSONAL INFORMATION</h2>

            <p>
              We may transfer personal information that we collect or that you provide as described in this policy to
              contractors, service providers, and other third parties we use to support our business (such as analytics
              and search engine providers that assist us with Website improvement and optimization) and who are
              contractually obligated to keep personal information confidential, use it only for the purposes for which
              we disclose it to them, and to process the personal information with the same standards set out in this
              policy.
            </p>
            <p>
              <br />
            </p>
            <p>
              We may process, store, and transfer your personal information in and to a foreign country, with different
              privacy laws that may or may not be as comprehensive as Canadian law. In these circumstances, the
              governments, courts, law enforcement, or regulatory agencies of that country may be able to obtain access
              to your personal information through the laws of the foreign country. Whenever we engage a service
              provider, we require that its privacy and security standards adhere to this policy and applicable Canadian
              privacy legislation.
            </p>
            <p>
              <br />
            </p>
            <p>
              By submitting your personal information or engaging with the Website, you consent to this transfer,
              storage, or processing.
            </p>

            <h2 className={styles.heading}>6. CHOICES ABOUT HOW WE USE AND DISCLOSE YOUR INFORMATION</h2>

            <p>
              We strive to provide you with choices regarding the personal information you provide to us. We have
              created mechanisms to provide you with the following control over your information:
            </p>
            <ul className={twMerge(`${styles.bullet}`, 'ml-[50px]')}>
              <li>
                <b>Tracking Technologies and Advertising.</b> You can set your browser to refuse all or some browser
                cookies, or to alert you when cookies are being sent. If you disable or refuse cookies, please note that
                some parts of this Website may not be accessible or may not function properly.
              </li>
              <li>
                <b>Third-Party Advertising.</b> If you do not want us to share your personal information with
                unaffiliated or non-agent third parties for promotional purposes, you can opt-out by checking the
                relevant box located on the form where we collect your data. You can also opt-out by sending us an email
                stating your request to{' '}
                <a href="mailto:privacy@unreserved.com" target="_blank" rel="noreferrer">
                  privacy@unreserved.com
                </a>
                .
              </li>
              <li>
                <p>
                  <b>Promotional Offers from the Company.</b> If you have opted in to receive certain emails from us but
                  no longer wish to have your email address/contact information used by us to promote our own or third
                  parties&lsquo; products or services, you can opt-out by checking the relevant box located on the form
                  on which we collect your data or by sending us an email stating your request to{' '}
                  <a href="mailto:privacy@unreserved.com" target="_blank" rel="noreferrer">
                    privacy@unreserved.com
                  </a>
                  . If we have sent you a promotional email, you may unsubscribe by clicking the unsubscribe link we
                  have included in the email. This opt-out does not apply to information provided to us as part of the
                  use of our services.
                </p>
                <p>
                  <br />
                </p>
                <p>
                  You can opt-out of several third party ad servers&lsquo; and networks&lsquo; cookies simultaneously by
                  using an opt-out tool created by the Digital Advertising Alliance of Canada or an opt-out tool created
                  by the Network Advertising Initiative. You can also access these websites to learn more about online
                  behavioural advertising and how to stop websites from placing cookies on your device. Opting out of a
                  network does not mean you will no longer receive online advertising. It does mean that the network
                  from which you opted out will no longer deliver ads tailored to your web preferences and usage
                  patterns.
                </p>
                <p>
                  <br />
                </p>
                <p>
                  We do not control these third parties&lsquo; tracking technologies or how they are used. If you have
                  any questions about an advertisement or other targeted content, you should contact the responsible
                  provider directly.
                </p>
              </li>
            </ul>

            <h2 className={styles.heading}>7. DATA SECURITY</h2>
            <p>
              The security of your personal information is very important to us. We use physical, electronic, and
              administrative measures designed to secure your personal information from accidental loss and from
              unauthorized access, use, alteration, and disclosure.
            </p>
            <p>
              <br />
            </p>
            <p>
              The safety and security of your information also depends on you. Where we have given you (or where you
              have chosen) a password for access to certain parts of our Website, you are responsible for keeping this
              password confidential. We ask you not to share your password with anyone.
            </p>
            <p>
              <br />
            </p>
            <p>
              Unfortunately, the transmission of information via the Internet is not completely secure. Although, we do
              our best to protect your personal information, we cannot guarantee the security of your personal
              information transmitted to our Website. Any transmission of personal information is at your own risk. We
              are not responsible for circumvention of any privacy settings or security measures contained on the
              Website.
            </p>

            <h2 className={styles.heading}>8. DATA RETENTION</h2>

            <p>
              Except as otherwise permitted or required by applicable law or regulation, we will only retain your
              personal information for as long as necessary to fulfill the purposes we collected it for, including for
              the purposes of satisfying any legal, accounting, or reporting requirements.
            </p>
            <p>
              <br />
            </p>
            <p>
              Under some circumstances we may anonymize your personal information so that it can no longer be associated
              with you. We reserve the right to use such anonymous and de-identified data for any legitimate business
              purpose without further notice to you or your consent.
            </p>

            <h2 className={styles.heading}>9. ACCESSING AND CORRECTING YOUR PERSONAL INFORMATION</h2>

            <p>
              It is important that the personal information we hold about you is accurate and current. Please keep us
              informed if your personal information changes. By law you have the right to request access to and to
              correct the personal information that we hold about you.
            </p>
            <p>
              <br />
            </p>
            <p>
              If you want to review, verify, correct, or withdraw consent to the use of your personal information you
              may contact our Privacy Officer at (email address) to request access to, correct, or delete any personal
              information that you have provided to us. We may not accommodate a request to change information if we
              believe the change would violate any law or legal requirement or cause the information to be incorrect. We
              may a charge you a reasonable fee to access your personal information, however, we will notify you of any
              fee in advance.
            </p>
            <p>
              <br />
            </p>
            <p>
              We may request specific information from you to help us confirm your identity and your right to access,
              and to provide you with the personal information that we hold about you or make your requested changes.
              Applicable law may allow or require us to refuse to provide you with access to some or all of the personal
              information that we hold about you, or we may have destroyed, erased, or made your personal information
              anonymous in accordance with our record retention obligations and practices. If we cannot provide you with
              access to your personal information, we will inform you of the reasons why, subject to any legal or
              regulatory restrictions.
            </p>
            <p>
              We will provide access to your personal information, subject to exceptions set out in applicable privacy
              legislation. Examples of such exceptions include information:
            </p>
            <ul className={twMerge(`${styles.bullet}`, 'ml-[50px]')}>
              <li>protected by solicitor-client privilege;</li>

              <li>that is part of a formal dispute resolution process;</li>

              <li>
                that is about another individual that would reveal their personal information or confidential commercial
                information; or
              </li>

              <li>that is prohibitively expensive to provide.</li>
            </ul>
            <p>
              <br />
            </p>
            <p>
              If you delete your User Contributions from the Website, copies of your User Contributions may remain
              viewable in cached and archived pages or might have been copied or stored by other Website users.
            </p>

            <h2 className={styles.heading}>10. CHANGES TO OUR PRIVACY POLICY</h2>
            <p>
              It is our policy to post any changes we make to our privacy policy on this page with a notice that the
              privacy policy has been updated on the Website home page. If we make material changes to how we treat our
              users&lsquo; personal information, we will notify you by email to the primary email address specified in
              your account.
            </p>
            <p>
              <br />
            </p>
            <p>
              We include the date the privacy policy was last revised at the top of the page. You are responsible for
              ensuring we have an up-to-date, active, and deliverable email address for you, and for periodically
              visiting our Website and this privacy policy to check for any changes.
            </p>

            <h2 className={styles.heading}>11. CONTACT INFORMATION AND CHALLENGING COMPLIANCE</h2>

            <p>
              We welcome your questions, comments, and requests regarding this privacy policy and our privacy practices.
              Please contact us at:{' '}
              <a href="mailto:privacy@unreserved.com" target="_blank" rel="noreferrer">
                privacy@unreserved.com
              </a>
              .
            </p>
            <p>
              <br />
            </p>
            <p>
              We have procedures in place to receive and respond to complaints or inquiries about our handling of
              personal information, our compliance with this policy, and with applicable privacy laws. To discuss our
              compliance with this policy please contact our Privacy Officer using the contact information listed above.
            </p>
            <p>
              <br />
            </p>
            <p>
              If you are not satisfied with the decision reached by Unreserved in response to your complaint or request,
              you can address your concerns to Office of the Privacy Commissioner of Canada at 30, Victoria Street,
              Gatineau, Quebec, K1A 1H3.
            </p>
          </div>
        </ResponsiveWidth>
      </div>
      <div className="hidden md:block">
        <Footer />
      </div>
      <div className="block md:hidden">
        <FooterMobile />
      </div>
    </div>);
}
PrivacyPolicy.getInitialProps = async () => ({});
const __Next_Translate__Page__1955d79d38d__ = PrivacyPolicy;

    export default __appWithI18n(__Next_Translate__Page__1955d79d38d__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  